export default {
  APP_VERSION: "0.2.0",
  APP_NAME: "TESTGOLABS",
  S3_BUCKET_URL: process.env.VUE_APP_S3_BUCKET_URL,
  API_URL: process.env.VUE_APP_API_URL,
};
